import { render, staticRenderFns } from "./ChatProductCard.vue?vue&type=template&id=9aa6f6cc&"
import script from "./ChatProductCard.vue?vue&type=script&lang=js&"
export * from "./ChatProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports